import { Field, Select } from "./ui";
import { PROVINCES } from "@/lib/format";
import type { Address } from "@/lib/types";

export const EMPTY_ADDRESS: Address = {
  contact_name: "",
  phone: "",
  email: "",
  company_name: "",
  street: "",
  complex: "",
  suburb: "",
  city: "",
  province: "Gauteng",
  postal_code: "",
  instructions: "",
};

export function AddressForm({
  value,
  onChange,
  errors = {},
  prefix,
}: {
  value: Address;
  onChange: (next: Address) => void;
  errors?: Record<string, string>;
  prefix: "collection" | "delivery";
}) {
  const set = (key: keyof Address) => (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
    onChange({ ...value, [key]: event.target.value });

  const error = (key: string) => errors[`${prefix}.${key}`];

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <Field label="Contact name" name={`${prefix}-contact`} value={value.contact_name} onChange={set("contact_name")} error={error("contact_name")} />
      <Field label="Phone" name={`${prefix}-phone`} inputMode="tel" value={value.phone} onChange={set("phone")} error={error("phone")} />
      <Field label="Company (optional)" name={`${prefix}-company`} value={value.company_name ?? ""} onChange={set("company_name")} className="sm:col-span-2" />
      <Field label="Street address" name={`${prefix}-street`} value={value.street} onChange={set("street")} error={error("street")} className="sm:col-span-2" />
      <Field label="Complex or unit (optional)" name={`${prefix}-complex`} value={value.complex ?? ""} onChange={set("complex")} />
      <Field label="Suburb" name={`${prefix}-suburb`} value={value.suburb} onChange={set("suburb")} error={error("suburb")} />
      <Field label="City" name={`${prefix}-city`} value={value.city} onChange={set("city")} error={error("city")} />
      <Select
        label="Province"
        name={`${prefix}-province`}
        value={value.province}
        onChange={set("province")}
        error={error("province")}
        options={PROVINCES.map((p) => ({ value: p, label: p }))}
      />
      <Field
        label="Postal code"
        name={`${prefix}-postal`}
        inputMode="numeric"
        maxLength={4}
        value={value.postal_code}
        onChange={set("postal_code")}
        error={error("postal_code")}
      />
      <Field
        label="Instructions for the driver (optional)"
        name={`${prefix}-instructions`}
        value={value.instructions ?? ""}
        onChange={set("instructions")}
        className="sm:col-span-2"
        hint="Gate codes, buzzer numbers, where to find reception."
      />
    </div>
  );
}
